import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ProfileService} from '../../services/profile.service';
import {Observable} from 'rxjs';
import {Profile} from '../../model/profile';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {KeycloakService} from 'keycloak-angular';
import {FaqCategoryService} from '../../services/faq-category.service';
import {FaqCategory} from '../../model/FaqCategory';
import {CommonModule} from "@angular/common";
import {BreadcrumbComponent} from "../../components/common/breadcrumb/breadcrumb.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {RouterLink} from "@angular/router";
import {
  DashBlockCommercialComponent
} from "../../components/user/dash-block/dash-block-commercial/dash-block-commercial.component";
import {DashBlockDpComponent} from "../../components/user/dash-block/dash-block-dp/dash-block-dp.component";
import {BadgeComponent} from "../../components/common/badge/badge.component";
import {CancelButtonComponent} from "../../components/common/cancel-button/cancel-button.component";

@Component({
    selector: 'app-account',
    imports: [
        CommonModule,
        BreadcrumbComponent,
        FaIconComponent,
        RouterLink,
        DashBlockCommercialComponent,
        DashBlockDpComponent,
        BadgeComponent,
        CancelButtonComponent,
    ],
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.css']
})
export class AccountComponent implements OnInit {


  @ViewChild('requestresetmodal') requestresetmodal: TemplateRef<any>;
  @ViewChild('disableaccountmodal') disableaccountmodal: TemplateRef<any>;

  $profile: Observable<Profile>;
  categories: FaqCategory[];
  hasDp = true;

  constructor(private keycloakService: KeycloakService,
              private profileService: ProfileService,
              private modalService: NgbModal,
              private toastr: ToastrService,
              private faqCategoryService: FaqCategoryService) {
  }

  ngOnInit(): void {
    this.$profile = this.profileService.getProfile();
    this.faqCategoryService.getObjects().subscribe(cat => this.categories = cat);
  }

  resetPasswordRequest(): void {
    this.modalService.open(this.requestresetmodal).result.then(() => {
      this.profileService.resetPasswordRequest().subscribe(() => {
        this.toastr.success('Demande de modification de mot de passe envoyée.');
      });
    }).catch(() => {
      // modal closed
    });
  }

  deleteAccountRequest(): void {
    this.modalService.open(this.disableaccountmodal).result.then(() => {
      this.profileService.deleteMeRequest().subscribe(() => {
        this.toastr.error('Demande de suppression envoyée. Vous allez être déconnecté...');
        setTimeout(() => {
          this.keycloakService.logout();
        }, 3000);
      });
    }).catch(() => {
      // modal closed
    });
  }

}
